// extracted by mini-css-extract-plugin
export default {"card":"style_card__F+Hou","content":"style_content__ODQN3","empty":"style_empty__b9UMk"};